import React from "react";
import notificationIcon from "../../../assets/img/notification-icon.svg";
import userProfile from "../../../assets/img/profile-icon.svg";
import HorizontalBarChart from "../../../pages/Graphs/HorizontalBarChart";
import { useSelector } from "react-redux";

interface DataPoint {
  usersCount: {
    D1: number;
    D2: number;
    D3: number;
    D4: number;
    D5: number;
    D6: number;
    D7: number;
  };
  totalOrganizations: number;
  totalCategories: number;
  totalBudget: number;
  totalDataElements: number;
}
const AdminDashboardSocialLinks: React.FC<{ graphData: DataPoint }> = ({
  graphData,
}) => {
  const user = useSelector((state: any) => state?.Auth);
  return (
    <div className="w-full lg:w-[calc(25%-11px)] ">
      <div className="user-profile-col-wrapper bg-[#10151A] rounded-[10px] px-[16px] 2xl:px-[20px] py-[24px] mb-[20px]">
        <div className="flex gap-[14px] items-center">
          <div className="inline-flex p-1 border border-dashed border-[#A2A2A2] bg-dark rounded-full size-[54px] relative">
            <div className="inline-flex items-center justify-center p-2 bg-[#D9D9D9] size-[45px] min-w-[45px] rounded-full overflow-hidden">
              <img
                src={user?.user?.user?.profilePhoto || userProfile}
                alt="profile-icon"
                className="max-w-[40px] h-[40px] object-cover"
              />
            </div>

            <span className="rounded-full bg-[#51D15E] size-[15px] border border2 border-[#000] absolute bottom-px right-0"></span>
          </div>

          <div>
            <h4 className="text-sm 2xl:text-[16px]">
              {user?.user?.user?.name}
            </h4>
            <span className="user-email-col text-white break-all text-[12px] 2xl:text-[14px]">
              {user?.user?.user?.email}
            </span>
          </div>
        </div>

        <span className="profile-bottom-line block h-px my-[15px]"> </span>

        <div className="flex gap-[10px] flex-wrap">
          <div className="2xl:w-[calc(20%-8px)]">
            <div className="inline-flex items-center justify-center p-2 xl:p-[5px]  2xl:p-2 bg-primary rounded-full ">
              <svg
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15_9450)">
                  <path
                    d="M6.07227 4.63418C6.07203 5.10241 5.88744 5.55136 5.55908 5.88228C5.23073 6.2132 4.78552 6.39898 4.32139 6.39874C3.85726 6.39851 3.41223 6.21228 3.08421 5.88103C2.75619 5.54978 2.57203 5.10064 2.57227 4.63242C2.5725 4.16419 2.75709 3.71524 3.08545 3.38432C3.4138 3.0534 3.85901 2.86762 4.32314 2.86786C4.78727 2.86809 5.2323 3.05432 5.56032 3.38557C5.88835 3.71682 6.0725 4.16596 6.07227 4.63418ZM6.12477 7.70605H2.62477V18.7577H6.12477V7.70605ZM11.6548 7.70605H8.17227V18.7577H11.6198V12.9582C11.6198 9.72748 15.7935 9.42736 15.7935 12.9582V18.7577H19.2498V11.7577C19.2498 6.31135 13.0723 6.51438 11.6198 9.18902L11.6548 7.70605Z"
                    fill="#909090"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_9450">
                    <rect
                      width="21"
                      height="21.1853"
                      fill="white"
                      transform="translate(0 0.220581)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="2xl:w-[calc(20%-8px)]">
            <div className="inline-flex items-center justify-center p-2 xl:p-[5px]  2xl:p-2 bg-primary rounded-full ">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15_9451)">
                  <path
                    d="M7.25301 18.8601L7.97701 19.2868C9.19795 20.0052 10.5866 20.3823 12 20.3794C13.5823 20.3794 15.129 19.906 16.4446 19.0192C17.7602 18.1324 18.7855 16.872 19.3911 15.3973C19.9966 13.9225 20.155 12.2998 19.8463 10.7343C19.5376 9.16874 18.7757 7.7307 17.6569 6.602C16.538 5.47331 15.1126 4.70466 13.5607 4.39326C12.0089 4.08185 10.4004 4.24168 8.93855 4.85252C7.47674 5.46336 6.22731 6.49779 5.34826 7.82499C4.46921 9.15219 4.00001 10.7126 4.00001 12.3088C4.00001 13.7574 4.37701 15.1466 5.08401 16.3683L5.50601 17.0987L4.85301 19.5209L7.25301 18.8601ZM2.00401 22.397L3.35601 17.3852C2.46515 15.8446 1.99711 14.0924 2.00001 12.3088C2.00001 6.73704 6.47701 2.22054 12 2.22054C17.523 2.22054 22 6.73704 22 12.3088C22 17.8805 17.523 22.397 12 22.397C10.2328 22.3999 8.49667 21.9281 6.97001 21.0301L2.00401 22.397ZM8.39101 7.57537C8.52501 7.56528 8.66001 7.56528 8.79401 7.57134C8.84801 7.57537 8.90201 7.58142 8.95601 7.58748C9.11501 7.60564 9.29001 7.70349 9.34901 7.83867C9.64701 8.52064 9.93701 9.20765 10.217 9.89667C10.279 10.05 10.242 10.2467 10.124 10.4384C10.0429 10.568 9.95507 10.6933 9.86101 10.8137C9.74801 10.96 9.50501 11.2283 9.50501 11.2283C9.50501 11.2283 9.40601 11.3474 9.44401 11.4957C9.45801 11.5522 9.50401 11.6339 9.54601 11.7025L9.60501 11.7983C9.86101 12.2291 10.205 12.6659 10.625 13.0775C10.745 13.1945 10.862 13.3146 10.988 13.4265C11.456 13.8432 11.986 14.1832 12.558 14.4354L12.563 14.4374C12.648 14.4747 12.691 14.4949 12.815 14.5484C12.877 14.5746 12.941 14.5978 13.006 14.6149C13.0732 14.6322 13.1439 14.629 13.2093 14.6056C13.2746 14.5823 13.3316 14.5399 13.373 14.4838C14.097 13.5991 14.163 13.5416 14.169 13.5416V13.5436C14.2193 13.4962 14.2791 13.4603 14.3443 13.4382C14.4095 13.4161 14.4786 13.4084 14.547 13.4155C14.607 13.4195 14.668 13.4306 14.724 13.4558C15.255 13.7009 16.124 14.0833 16.124 14.0833L16.706 14.3466C16.804 14.394 16.893 14.506 16.896 14.6139C16.9 14.6815 16.906 14.7905 16.883 14.9902C16.851 15.2515 16.773 15.5653 16.695 15.7297C16.6416 15.8419 16.5707 15.9448 16.485 16.0344C16.3841 16.1412 16.2736 16.2385 16.155 16.3249C16.114 16.356 16.0723 16.3863 16.03 16.4157C15.9056 16.4953 15.7778 16.5694 15.647 16.6376C15.3895 16.7756 15.1052 16.8548 14.814 16.8697C14.629 16.8798 14.444 16.8939 14.258 16.8838C14.25 16.8838 13.69 16.796 13.69 16.796C12.2683 16.4188 10.9534 15.712 9.85001 14.732C9.62401 14.5312 9.41501 14.3153 9.20101 14.1004C8.31101 13.2076 7.63901 12.2442 7.23101 11.3342C7.02218 10.8876 6.90938 10.4015 6.90001 9.90777C6.89589 9.29527 7.09436 8.69886 7.46401 8.21295C7.53701 8.11812 7.60601 8.01925 7.72501 7.90526C7.85201 7.7842 7.93201 7.71963 8.01901 7.67524C8.13469 7.61676 8.26088 7.58245 8.39001 7.57436L8.39101 7.57537Z"
                    fill="#909090"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_9451">
                    <rect
                      width="24"
                      height="24.2118"
                      fill="white"
                      transform="translate(0 0.202881)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="2xl:w-[calc(20%-8px)]">
            <div className="inline-flex items-center justify-center p-2 xl:p-[5px]  2xl:p-2 bg-primary rounded-full ">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15_9449)">
                  <path
                    d="M13.0042 18.7884C13.428 18.7224 13.8617 18.7957 14.2412 18.9973C14.8549 19.3228 15.5558 19.4417 16.2414 19.3367C16.9269 19.2317 17.5612 18.9082 18.0515 18.4135C18.5419 17.9189 18.8625 17.279 18.9666 16.5874C19.0707 15.8958 18.9528 15.1887 18.6302 14.5695C18.4303 14.1867 18.3577 13.7492 18.4232 13.3216C18.5815 12.3012 18.4986 11.2576 18.1814 10.2756C17.8642 9.29361 17.3215 8.40112 16.5975 7.67081C15.8736 6.94051 14.9889 6.39303 14.0156 6.07299C13.0422 5.75294 12.0076 5.66938 10.9962 5.82909C10.5723 5.89509 10.1386 5.82188 9.75916 5.62027C9.14529 5.29451 8.44421 5.17543 7.75844 5.28043C7.07267 5.38544 6.4382 5.70902 5.94779 6.20387C5.45738 6.69872 5.13677 7.33887 5.03284 8.03071C4.92891 8.72255 5.04711 9.42979 5.37016 10.049C5.57 10.4318 5.64257 10.8693 5.57716 11.2969C5.41884 12.3173 5.50167 13.361 5.81892 14.343C6.13616 15.3249 6.67885 16.2174 7.40277 16.9477C8.12669 17.678 9.01137 18.2255 9.98475 18.5456C10.9581 18.8656 11.9927 18.9492 13.0042 18.7894V18.7884ZM12.0002 20.8838C10.773 20.884 9.56037 20.6162 8.44558 20.0987C7.33079 19.5812 6.34028 18.8264 5.54214 17.886C4.74399 16.9457 4.15714 15.8421 3.82191 14.6513C3.48668 13.4604 3.41103 12.2104 3.60016 10.9872C3.07889 9.98697 2.88841 8.84476 3.05657 7.72751C3.22472 6.61027 3.74269 5.57657 4.53477 4.77751C5.32684 3.97844 6.3515 3.4559 7.45897 3.28626C8.56644 3.11663 9.69867 3.30878 10.6902 3.83465C12.0125 3.62628 13.3648 3.73584 14.6372 4.15442C15.9096 4.573 17.0661 5.28878 18.0124 6.24347C18.9588 7.19817 19.6683 8.3648 20.0832 9.64842C20.4981 10.932 20.6067 12.2964 20.4002 13.6303C20.9214 14.6306 21.1119 15.7728 20.9437 16.89C20.7756 18.0073 20.2576 19.041 19.4655 19.84C18.6735 20.6391 17.6488 21.1616 16.5413 21.3313C15.4339 21.5009 14.3016 21.3088 13.3102 20.7829C12.8832 20.8495 12.4452 20.8838 12.0002 20.8838ZM12.0532 17.3529C9.25016 17.3529 8.00016 15.9607 8.00016 14.9176C8.00016 14.3809 8.39016 14.0076 8.92816 14.0076C10.1282 14.0076 9.81516 15.7478 12.0532 15.7478C13.1962 15.7478 13.8292 15.1183 13.8292 14.4757C13.8292 14.0883 13.6412 13.6606 12.8862 13.4709L10.3962 12.8424C8.39016 12.334 8.02616 11.2364 8.02616 10.2074C8.02616 8.06868 10.0182 7.26465 11.8902 7.26465C13.6102 7.26465 15.6462 8.22909 15.6462 9.51231C15.6462 10.0621 15.1662 10.3829 14.6342 10.3829C13.6112 10.3829 13.7992 8.95241 11.7342 8.95241C10.7112 8.95241 10.1382 9.41849 10.1382 10.0883C10.1382 10.7572 10.9412 10.9721 11.6402 11.1325L13.4762 11.5451C15.4902 12.0011 16.0002 13.1925 16.0002 14.3153C16.0002 16.0545 14.6752 17.3529 12.0152 17.3529H12.0532Z"
                    fill="#909090"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_9449">
                    <rect
                      width="24"
                      height="24.2118"
                      fill="white"
                      transform="translate(0 0.202881)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="2xl:w-[calc(20%-8px)]">
            <div className="inline-flex items-center justify-center p-2 xl:p-[5px]  2xl:p-2 bg-primary rounded-full ">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_15_9452)">
                  <path
                    d="M9.366 10.9791C10.3043 12.6422 11.6695 14.0194 13.318 14.966L14.202 13.7171C14.3442 13.5163 14.5543 13.375 14.7928 13.3199C15.0313 13.2649 15.2814 13.3 15.496 13.4185C16.9103 14.1982 18.4722 14.6672 20.079 14.7945C20.3298 14.8146 20.5638 14.9292 20.7345 15.1156C20.9052 15.3021 21 15.5465 21 15.8003V20.3017C21.0001 20.5515 20.9083 20.7924 20.7424 20.9778C20.5765 21.1632 20.3483 21.28 20.102 21.3055C19.572 21.3609 19.038 21.3882 18.5 21.3882C9.94 21.3882 3 14.3869 3 5.75141C3 5.20867 3.027 4.66996 3.082 4.13528C3.10725 3.8868 3.22298 3.65661 3.40679 3.48926C3.5906 3.32191 3.82941 3.2293 4.077 3.22935H8.539C8.79056 3.22932 9.0329 3.32494 9.21768 3.49715C9.40247 3.66935 9.51613 3.90549 9.536 4.15848C9.66222 5.77945 10.1271 7.35512 10.9 8.78192C11.0175 8.99838 11.0522 9.25076 10.9977 9.49132C10.9431 9.73188 10.8031 9.94393 10.604 10.0873L9.366 10.9791ZM6.844 10.3163L8.744 8.94737C8.20478 7.77319 7.83535 6.52704 7.647 5.247H5.01C5.004 5.41447 5.001 5.58294 5.001 5.75141C5 13.2732 11.044 19.3705 18.5 19.3705C18.667 19.3705 18.834 19.3675 19 19.3604V16.7002C17.7312 16.5102 16.4959 16.1375 15.332 15.5935L13.975 17.5103C13.4287 17.2961 12.898 17.0433 12.387 16.7536L12.329 16.7204C10.3676 15.5942 8.74328 13.9556 7.627 11.9769L7.594 11.9184C7.30691 11.4028 7.05628 10.8675 6.844 10.3163Z"
                    fill="#909090"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15_9452">
                    <rect
                      width="24"
                      height="24.2118"
                      fill="white"
                      transform="translate(0 0.202881)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div className="2xl:w-[calc(20%-8px)]">
            <div className="inline-flex items-center justify-center p-2 xl:p-[5px]  2xl:p-2 bg-primary rounded-full ">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2003_19386"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2003_19386)">
                  <path
                    d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z"
                    fill="#909090"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <HorizontalBarChart graphData={graphData?.usersCount} />
      {/* <HorizontalBarChart graphData={graphData.usersCount} /> */}

      <div className="notification-col-wrapper flex gap-[15px] items-center rounded-[15px] py-[20px] px-[12px] bg-[#10151A]">
        <div>
          <img src={notificationIcon} alt="icon" className="w-full" />
        </div>

        <div>
          {/* <h4 className="text-[12px] mb-[7px]">Dear John,</h4> */}
          <p className="text-[12px] break-words ">
            There are no notifications for you today.
          </p>
        </div>
      </div>
      {/* <GradientBarChart data={sampleData} title="Del (Delivery)" /> */}
    </div>
  );
};

export default AdminDashboardSocialLinks;
